<template>
    <div
        class="tw-flex tw-items-center tw-justify-center tw-border-0 tw-border-b tw-border-solid tw-border-gray-100 tw-mb-8 legacy:tw-text-sm tw-uppercase"
    >
        <div class="tw-flex-1">
            <ul class="list-unstyled tw-m-0" role="tablist">
                <li
                    v-for="(tab, index) in visibleTabs"
                    :key="tab.id || tab.label || index"
                    role="tab"
                    :tabindex="selectedTabIndex === index ? 0 : -1"
                    :aria-selected="selectedTabIndex === index ? true : false"
                    class="tw-w-1/2 sm:tw-w-auto tw-inline-block"
                >
                    <a
                        :href="tab.href || '#'"
                        class="tw-flex sm:tw-inline-flex tw-items-baseline tw-justify-center legacy:tab-spacing tw-border-0 tw-border-b-2 tw-border-solid legacy:tw-border-b-3 tw-border-transparent tw-text-gray-400 hover:tw-text-indigo-500 focus:tw-text-indigo-500 tw-cursor-pointer"
                        :class="{
                            'tw-text-indigo-500 tw-font-semibold tw-border-indigo-500':
                                selectedTabIndex === index && !tab.href,
                        }"
                        :data-test-id="tab.testId || ''"
                        @click="onTabSelect(index, $event)"
                    >
                        <i v-if="tab.iconClass" class="tw-mr-2" :class="tab.iconClass" />
                        <span class="tw-inline-block tw-truncate">{{ tab.label }}</span>
                        <i v-if="tab.href" class="fal fa-caret-right tw-ml-2" />
                    </a>
                </li>
            </ul>
        </div>

        <div class="tw-ml-4 sm:tw-ml-0 tw-flex-grow-0"><slot /></div>
    </div>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            default: () => [],
        },
        selected: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            selectedTabIndex: null,
        };
    },
    computed: {
        visibleTabs() {
            return this.tabs.filter(tab => tab.visible !== false && tab.show !== false);
        },
    },
    watch: {
        visibleTabs: {
            immediate: true,
            deep: true,
            handler(newValue) {
                const index = newValue.findIndex(tab => !tab.href && tab.id === this.selected?.id);

                if (index === -1) {
                    this.selectedTabIndex = 0;
                    return;
                }

                this.selectedTabIndex = index;
            },
        },
        selected: {
            deep: true,
            handler(newValue) {
                const index = this.visibleTabs.findIndex(
                    tab => !tab.href && tab.id === newValue.id,
                );

                if (index === -1) {
                    this.selectedTabIndex = 0;
                    return;
                }

                this.selectedTabIndex = index;
            },
        },
    },
    methods: {
        onTabSelect(index = 0, event) {
            if (!this.visibleTabs[index].href) {
                event.preventDefault();
                if (index === this.selectedTabIndex) return;
                this.$emit("update:selected", this.visibleTabs[index]);
                this.$emit("tabSelect", this.visibleTabs[index]);
            }

            this.selectedTabIndex = index;
        },
    },
};
</script>

<style scoped>
.legacy\:tw-border-b-3 {
    border-bottom-width: 3px;
}

.legacy\:tw-text-sm {
    font-size: 13px;
}

.legacy\:tab-spacing {
    padding: 15px 7px 12px 7px;
}
</style>
